var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form_box"},[(_vm.step === 2 || _vm.step === 3 || _vm.step === 4)?_c('circle-navigation',_vm._g({attrs:{"step":_vm.step}},_vm.$listeners)):_vm._e(),_vm._v(" "),_c('router-view',_vm._g({attrs:{"header":_vm.currentStepHeader,"fullName":_vm.fullName,"appName":_vm.appName}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }